import { Container, FlexBox } from "@components/wrapper"
import clsx from "clsx"
import React from "react"
import { BootcampHeading } from "../general/ProgramHeading"
import { ProgramNewCta } from "../proclass"

const PROCESS = [
  {
    title: "Daftar",
    subTitle: "Daftarkan akun di harisenin.com",
  },
  {
    title: "Pilih Program",
    subTitle: "Pilih program melalui web harisenin.com",
  },
  {
    title: "Bayar",
    subTitle: "Bayar lunas melalui web/cicilan lewat CS",
  },
  {
    title: "Mulai Belajar",
    subTitle: "Mulai pengalaman belajarmu sekarang!",
  },
]

export const BootcampRegistrations = () => {
  return (
    <div className="bg-[#101820] sm:py-20 py-10 relative">
      <Container className="relative grid sm:gap-9 gap-6">
        <div className="relative">
          <BootcampHeading
            id="registrations"
            title="proses pendaftaran"
            subTitle="Tanpa Test. Semua Bisa Belajar."
            type="green"
          />
        </div>

        <div className="grid sm:grid-cols-4 sm:gap-9 gap-3">
          {PROCESS.map((prog, idx) => (
            <FlexBox key={idx} className={clsx("bg-white rounded-lg", "gap-1.5 sm:p-6 p-5")}>
              <div className={clsx("font-bold", "sm:text-2xl text-lg sm:w-[42px] w-7")}>0{idx + 1}</div>
              <div className="grid sm:gap-2 gap-1 w-4/5">
                <div className={clsx("font-urbanist font-bold", "sm:text-2xl text-lg")}>{prog.title}</div>
                <div className="text-secondary-grey sm-only:text-sm">{prog.subTitle}</div>
              </div>
            </FlexBox>
          ))}
        </div>

        <ProgramNewCta withMargin={false} isBootcamp/>
      </Container>
    </div>
  )
}
